import { render } from "./TargetGroup.html?vue&type=template&id=72017e94&scoped=true&ts=true"
import script from "./TargetGroup.ts?vue&type=script&lang=ts"
export * from "./TargetGroup.ts?vue&type=script&lang=ts"

import "./TargetGroup.css?vue&type=style&index=0&id=72017e94&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72017e94"]])

export default __exports__